import Vue from 'vue'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

let csrfToken = null
let refreshPromise = null

export function setCsrfToken(token) {
  csrfToken = token || null
}

export function clearCsrfToken() {
  csrfToken = null
}

export function getCsrfToken() {
  return csrfToken
}

const axiosIns = axios.create({
  baseURL: window.config.apiBaseUrl,
  withCredentials: true,
})

axiosIns.interceptors.request.use(
  config => {
    const updatedConfig = { ...config }

    updatedConfig.headers = {
      ...config.headers,
      'X-Session-Mode': 'cookie',
    }

    if (csrfToken) {
      updatedConfig.headers['X-XSRF-TOKEN'] = csrfToken
    }

    return updatedConfig
  },
  error => Promise.reject(error),
)

async function ensureCsrfToken() {
  if (csrfToken) {
    return
  }

  const response = await axiosIns.get('/Auth/Csrf')
  setCsrfToken(response.data.csrf_token)
}

export function refreshSession() {
  if (!refreshPromise) {
    const requestId = uuidv4()
    const request = { request_id: requestId }

    refreshPromise = ensureCsrfToken()
      .then(() => axiosIns.post('/Auth/Refresh', request)
        .catch(error => {
          if (error.response) {
            throw error
          }

          return axiosIns.post('/Auth/Refresh', request)
        }))
      .finally(() => {
        refreshPromise = null
      })
  }

  return refreshPromise
}

Vue.prototype.$http = axiosIns

export default axiosIns
